import { useTranslation } from '@exam-room/translations';
import { cn } from '@exam-room/utils';
import { useController } from 'react-hook-form';

import { Form } from '../../../../../components';

interface CheckboxGroupProps {
  name: string;
  options: { label: string | JSX.Element; value: string; endAdornment?: React.ReactNode }[];
  disabled?: boolean;
  className?: HTMLFieldSetElement['className'];
}

function CheckboxGroup(props: Readonly<CheckboxGroupProps>) {
  const { name, options, disabled, className } = props;

  const { t } = useTranslation();

  const {
    field: { value, onChange, ref: fieldRef },
    fieldState: { error },
  } = useController({ name });

  const handleCheckboxChange = (checkboxValue: string, isChecked: boolean) => {
    if (isChecked) {
      onChange([...value, checkboxValue]);
    } else {
      const filteredValue = value.filter((item: string) => item !== checkboxValue);
      onChange(filteredValue);
    }
  };

  return (
    <fieldset
      className={cn(['text-text-primary grid', className])}
      ref={(ref) => {
        fieldRef({
          focus: () => ref?.scrollIntoView({ block: 'center' }),
        });
      }}
    >
      {options.map((option) => (
        <div key={option.value} className='flex gap-4'>
          <div className='py-2'>
            <Form.Checkbox
              name={name}
              value={option.value}
              checked={value && value.includes(option.value)}
              onChange={(e) => handleCheckboxChange(option.value, e.target.checked)}
              className='py-2'
              disabled={disabled}
            >
              {option.label}
            </Form.Checkbox>
          </div>
          {option.endAdornment}
        </div>
      ))}
      {error && error?.message ? (
        <p className='text-danger py-2 text-sm'>{t(error.message)}</p>
      ) : null}
    </fieldset>
  );
}

export default CheckboxGroup;
